import { TokenLogout } from 'API/Logout/logout';
import axios from 'axios';
// const url=process.env.REACT_APP_BACKEND_URL
const url = process.env.REACT_APP_BACKEND_URL;
const paymenturl = 'https://finvestaapiuat.fiaglobal.com';
const redirect_url = process.env.REACT_APP_REDIRECT_URL;
const statesUrl = process.env.REACT_APP_APPROVAL_URL

export const Getstates = async (setData) => {
  try {
    await axios.get(`${statesUrl}/unique_districts`).then((res) => {
      setData(res.data);
      console.log(res.data);
    });
  } catch (error) {
    // console.log(error);
    TokenLogout(error)
  }
};

export const GetSubdistrict = async (district, setData) => {
  try {
    await axios
      .get(`${url}/sub_districts`, {
        params: {
          district: district
        }
      })
      .then((res) => {
        setData(res.data);
        console.log(res.data);
      });
  } catch (error) {
    // console.log(error);
    TokenLogout(error)
  }
};

// DS POST DATA

export const PostApi = async (data, designation,handleClick, setErrMessage, setVerifyErr,setSentPaymnet,setData,setIsVerify,handlePanDialogClose,setPincodeDetails,handleBackdropOpen,handleBackdropClose) => {
  // const usertype = sessionStorage.getItem('UserType') === 'tm'? 'territory_manager' : sessionStorage.getItem('UserType') === 'ops'? 'operation_team' : sessionStorage.getItem('UserType') === 'sh' ? 'state_head' : sessionStorage.getItem('UserType') === 'rm' ? 'regional_manager' :'cso'
  // const formdata = new FormData();
  const postdata={
    "distributor_services_type":data.type_services?data.type_services:sessionStorage.getItem('type_services'),
    "distributor_type":data.type_distributor?data.type_distributor:sessionStorage.getItem('type_distributor'),
    "distributor_class":data.class_distributor?data.class_distributor:sessionStorage.getItem('class_distributor'),
    "first_name":data.first_name?data.first_name:sessionStorage.getItem('first_name'),
    "last_name":data.last_name ? data.last_name : '',
    "email_address":data.email_address?data.email_address:sessionStorage.getItem('email_address'),
    "mobile_number":data.mobile_number?data.mobile_number:sessionStorage.getItem('mobile_number'),
    "user_type":designation,
    "retail_address":data.retail_address?data.retail_address:sessionStorage.getItem('retail_address'),
    "retail_district":data.retail_district?data.retail_district:sessionStorage.getItem('retail_district'),
    "retail_sub_district":data.retail_sub_district?data.retail_sub_district:sessionStorage.getItem('retail_sub_district'),
    "retail_city_village":data.retail_village?data.retail_village:sessionStorage.getItem('retail_village'),
    "retail_pincode":data.retail_pincode?data.retail_pincode:sessionStorage.getItem('retail_pincode'),
    "retail_state":data.retail_state?data.retail_state:sessionStorage.getItem('retail_state'),
    "home_address":data.class_distributor!=="solo"&&data.class_distributor!=="individual"?data.home_address:null,
    "organization_name":data.class_distributor!=="solo"&&data.class_distributor!=="individual"?data.organization_name:null,
    "pan_number":data.class_distributor!=="solo"&&data.class_distributor!=="individual"?data.pan_number:null,
    "remarks":data.class_distributor!=="solo"&&data.class_distributor!=="individual"?data.remarks:null,
    "marital_status":data.marital_status?data.marital_status:sessionStorage.getItem("marital_status")

  }
  // formdata.append('distributor_services_type', data.type_services?data.type_services:sessionStorage.getItem('type_services'));
  // formdata.append('distributor_type', data.type_distributor?data.type_distributor:sessionStorage.getItem('type_distributor'));
  // formdata.append('distributor_class', data.class_distributor?data.class_distributor:sessionStorage.getItem('class_distributor'));
  // formdata.append('first_name', data.first_name?data.first_name:sessionStorage.getItem('first_name'));
  // formdata.append('last_name', data.last_name ? data.last_name : '');
  // formdata.append('email_address', data.email_address?data.email_address:sessionStorage.getItem('email_address'));
  // formdata.append('mobile_number', data.mobile_number?data.mobile_number:sessionStorage.getItem('mobile_number'));
  // formdata.append('user_type',designation);
  // formdata.append('retail_address', data.retail_address?data.retail_address:sessionStorage.getItem('retail_address'));
  // formdata.append('retail_district', data.retail_district?data.retail_district:sessionStorage.getItem('retail_district'));
  // formdata.append('retail_sub_district', data.retail_sub_district?data.retail_sub_district:sessionStorage.getItem('retail_sub_district'));
  // formdata.append('retail_village', data.retail_village?data.retail_village:sessionStorage.getItem('retail_village'));
  // formdata.append('retail_pincode', data.retail_pincode?data.retail_pincode:sessionStorage.getItem('retail_pincode'));
  // formdata.append('redirect_url',process.env.REACT_APP_REDIRECT_URL)
  try {
    handleBackdropOpen()
    const token = sessionStorage.getItem('token');
    const response = await axios.post(`${url}/ds/add`, postdata, {
      headers: {
        Authorization: `Bearer ${token}`
      }
      // withCredentials: true
    });

    if (response.status === 201) {
      handleBackdropClose()
      setErrMessage(response.data.message);
      handleClick();

      let token=sessionStorage.getItem('token');
      let UserType=sessionStorage.getItem('UserType');
      let isLoggedin=sessionStorage.getItem('isLoggedin');
      let UserName=sessionStorage.getItem('UserName')
      sessionStorage.clear()
      sessionStorage.setItem('token',token)
      sessionStorage.setItem('UserType',UserType)
      sessionStorage.setItem('isLoggedin',isLoggedin)
      sessionStorage.setItem('UserName',UserName)
      setSentPaymnet(true)
      setData({})
      setPincodeDetails(null)
      setIsVerify({email:false,mobile:false})
      handlePanDialogClose()

      setTimeout(()=>{
        window.location.reload()
      },1500)

      // setTimeout(()=>{
      //    PostPayment(formdata,setData,handleClick,setErrMessage,setVerifyErr)
      // },1000)
    }
  } catch (error) {
    console.log(error);
    handleBackdropClose()
    if (error.response && error.response.status === 401) {
      setErrMessage(error.response&&error.response.data.error?error.response.data.error:'Token expired please login again');
      setVerifyErr(true);
    } else if (error.response) {
      setErrMessage(error.response.data.error);
      setVerifyErr(true);
      TokenLogout(error)
    } else {
      setErrMessage('something went wrong');
      setVerifyErr(true);
      TokenLogout(error)
    }
  }
  finally{
    handleBackdropClose()
  }
};

// MDS POST DATA
export const MDSPostApi = async (data, handleClick, setErrMessage, setVerifyErr,setSentPaymnet) => {
  const usertype = sessionStorage.getItem('UserType') === 'tm'? 'territory_manager' : sessionStorage.getItem('UserType') === 'ops'? 'operation_team' : sessionStorage.getItem('UserType') === 'sh' ? 'state_head' : sessionStorage.getItem('UserType') === 'rm' ? 'regional_manager' :'cso'
  const formdata = new FormData();
  formdata.append('type_services', data.type_services);
  formdata.append('type_distributor', data.type_distributor);
  formdata.append('class_distributor', data.class_distributor);
  formdata.append('first_name', data.first_name);
  formdata.append('last_name', data.last_name ? data.last_name : '');
  formdata.append('email_address', data.email_address);
  formdata.append('mobile_number', data.mobile_number);
  formdata.append('distributor_added_by', usertype);
  formdata.append('refundable_amount', data.refundable ? data.refundable : '');
  formdata.append('non_refundable_amount', data.nonrefundable ? data.nonrefundable : '');
  formdata.append('total_amount', data.totalamount ? data.totalamount : '');
  formdata.append('user_name', data.first_name);

  // formdata.append('redirect_url',process.env.REACT_APP_REDIRECT_URL)
  try {
    const token = sessionStorage.getItem('token');
    const response = await axios.post(`${url}/tm/master_distributor/add`, formdata, {
      headers: {
        Authorization: `Bearer ${token}`
      }
      // withCredentials: true
    });

    if (response.status === 201) {
      setErrMessage('Email Sent');
      handleClick();

      setSentPaymnet(true)
    }
  } catch (error) {
    // console.log(error);
    if (error.response && error.response.status === 401) {
      setErrMessage(error.response&&error.response.data.error?error.response.data.error:'Token expired please login again');
      setVerifyErr(true);
      TokenLogout(error)
    } else if (error.response) {
      setErrMessage(error.response.data.error);
      setVerifyErr(true);
    } else {
      setErrMessage('something went wrong');
      setVerifyErr(true);
    }
  }
};

export const EmailOtpCall = async (email, setOpenOtpModal, setVerifyErr, setVerifyErrMsg,handleBackdropOpen,handleBackdropClose,setOtpCount,handleSuccessOpen) => {
  try {
    handleBackdropOpen()
    await axios
      .post(
        `${url}/ds/send_email`,
        {
          email: email&&email.toLowerCase()
        },
        {
          headers: {
            Authorization:`Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        handleBackdropClose()
        if (res.status === 200) {
          if (res.data.message === 'OTP has already been sent to the email') {
            setVerifyErrMsg('OTP has already been sent to the email');
            setVerifyErr(true);
          } else {
            setVerifyErrMsg(res.data.message);
            handleSuccessOpen();
            setOpenOtpModal(true)
            setOtpCount(120)

          }
        }
      });
  } catch (error) {
    handleBackdropClose()
    // console.log(error);
    setVerifyErrMsg(error&&error.response&&error.response.data.error?error.response.data.error:'Something went wrong!!');
    setVerifyErr(true);
    TokenLogout(error)
  }
};

export const VerifyEmail = async (email, otp, handleClick, setErrMessage, isVerified, setIsVerified, setOtp, handleCloseOtpModal,handleBackdropOpen,handleBackdropClose,setVerifyErr) => {
  try {
    handleBackdropOpen()
    await axios
      .post(
        `${url}/ds/verify_email`,
        {
          email: email&&email.toLowerCase(),
          otp: otp
        },
        {
          headers: {
            Authorization:`Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        handleBackdropClose()
        if (res.status === 200) {
          setErrMessage('Otp Verified');
          handleClick(true);
          sessionStorage.setItem("email_verified",true)
          setIsVerified({ ...isVerified, email: true });
          setOtp(null);
          handleCloseOtpModal();
        }
      });
  } catch (error) {
    handleBackdropClose()
    // console.log(error);
    TokenLogout(error)
    setErrMessage(error.response?error.response.data.error:'Something went wrong!!');
    setVerifyErr(true)
  }
};

export const PhoneOtpCall = async (number, setOpenOtpModal, setVerifyErr, setVerifyErrMsg,handleBackdropOpen,handleBackdropClose,setOtpCount,handleSuccessOpen) => {
  try {
    handleBackdropOpen()
    await axios
      .post(
        `${url}/ds/send_mess`,
        {
          mobile_number: number
        },
        {
          headers: {
            Authorization:`Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        handleBackdropClose()
        if (res.status === 200) {
          if (res.data.message === 'OTP has already been sent to the mobile_number') {
            setVerifyErrMsg('OTP has already been sent to the mobile number');
            setVerifyErr(true);
          } else {
            setVerifyErrMsg('OTP has been sent to the mobile number');
            handleSuccessOpen();
            setOpenOtpModal(true);
            setOtpCount(120)
          }
        }
      });
  } catch (error) {
    handleBackdropClose()
    setVerifyErrMsg(error&&error.response&&error.response.data.error?error.response.data.error:"Something went wrong")
    setVerifyErr(true);
    console.log(error);
    TokenLogout(error)
  }
};

export const VerifyPhone = async (number, otp, handleClick, setErrMessage, isVerified, setIsVerified, setOtp, handleCloseOtpModal,handleBackdropOpen,handleBackdropClose,setVerifyErr) => {
  try {
    handleBackdropOpen()
    await axios
      .post(
        `${url}/ds/verify_sms`,
        {
          mobile_number: number,
          otp: otp
        },
        {
          headers: {
            Authorization:`Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        handleBackdropClose()
        if (res.status === 200) {
          setErrMessage('Otp Verified');
          handleClick(true);
          sessionStorage.setItem("mobile_verified",true)
          setIsVerified({ ...isVerified, mobile: true });
          setOtp(null);
          handleCloseOtpModal();
        }
      });
  } catch (error) {
    handleBackdropClose()
    setErrMessage(error.response?error.response.data.error:"Something went wrong");
    setVerifyErr(true);
    TokenLogout(error)
  }
};

export const PostPayment = async (data, setData, handleClick, setErrMessage, setVerifyErr,Designation) => {
  console.log(redirect_url);
  // console.log('hitttt');
  // const formdata = new FormData();
  // formdata.append('type_services', data.type_services);
  // formdata.append('type_distributor', data.type_distributor);
  // formdata.append('class_distributor', data.class_distributor);
  // formdata.append('user_name', data.first_name);
  // formdata.append('last_name', data.last_name ? data.last_name : '');
  // formdata.append('email_address', data.email_address);
  // formdata.append('mobile_number', data.mobile_number);
  // formdata.append('address', data.home_address);
  // formdata.append('district', data.home_district);
  // formdata.append('sub_district', data.home_sub_district);
  // formdata.append('village/town', data.home_village);
  // formdata.append('pin_code', data.home_pincode);
  // formdata.append('state', data.home_state);
  // formdata.append('refundable_amount', data.refundable ? data.refundable : '');
  // formdata.append('non_refundable_amount', data.nonrefundable ? data.nonrefundable : '');
  // formdata.append('total_amount', data.totalamount ? data.totalamount : '');
  // let newData={...data,redirect_url:process.env.REACT_APP_REDIRECT_URL}
  // formdata.append('redirect_url', `${redirect_url}/Admin/dsonboarding`);
  // formdata.append('request_domain', 'tm_ds_onboarding');
  let postdata={

      "customer_name":data.first_name,
      "bill_delivery_type":"EMAIL",
      "customer_mobile_no":data.mobile_number,
      "customer_email_id":data.email_address,
      "customer_email_subject":"Payment for distributor onboarding",
      "invoice_description":"Payment for distributor onboarding",
      "valid_for":2,
      "valid_type":"days",
      "total_amount":`${data.totalamount}`,
      "refundable_amount":data.refundable?data.refundable:'',
      "non_refundable_amount":data.nonrefundable?data.nonrefundable:'',
      "user_type":Designation==="DS"?"Distributor":"Master_Distributor"
  }
  try {
    const token = sessionStorage.getItem('token');
    const response = await axios.post(`${paymenturl}/distributor-on-boarding/generate/invoice`, postdata, {
      headers: {
        'Authorization': `Bearer ${token}`,
        Profile: 'fiaglobal_FIA001'
      }

      // withCredentials: true
    });

    if (response.status === 200) {
      setErrMessage('Payment link sent successfully');
      handleClick();
      setData(true)
      setTimeout(()=>{
        window.location.href="/dashboard/default"
      },1500)
      // setData({});
      // setResponse(response.data);
      // const url = response.data.ccavenue_url;
      // Object.entries(data).map(([key,value])=>{
      //   sessionStorage.setItem(key,value)
      // })

    }
  } catch (error) {
    console.log(error);
    if (error.response && error.response.status === 401) {
      setErrMessage(error.response&&error.response.data.error?error.response.data.error:'Token expired please login again');
      setVerifyErr(true);
      TokenLogout(error)
    } else {
      setErrMessage(error.response?error.response.data.error:'something went wrong');
      setVerifyErr(true);
    }
  }
};
